export default __webpack_public_path__ + "static/media/open-sans-latin-400.347639ec.woff";